module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/point3_35b959905335524f4ad0e42f5d47ac8e.png";